var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"text-center",attrs:{"flat":_vm.flat}},[_c('v-progress-circular',{staticClass:"ma-5",attrs:{"size":50,"color":"primary","indeterminate":""}}),_c('v-card-title',{staticClass:"d-flex justify-center"},[_vm._v(_vm._s(this.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }